import styled from 'styled-components';
import { regularWhite, defaultTextMargin, fontWeightBold } from '../design-tokens';

export const PlayHeading = styled.div`
    color: ${regularWhite};
    margin-bottom: ${defaultTextMargin};
    font-weight: ${fontWeightBold};
`;
